import { ICTMENU_LOG_ACTION_TYPES } from '@/constants/search/ictLogTypes';

export const ICTMENU_TYPES = ['goBJ', 'clickNote', 'favorite', 'nickSearch'];

export const getIctMenuLogConfig = (type, userId) => {
  if (!ICTMENU_TYPES.includes(type)) return null;

  const ictConfig = ICTMENU_LOG_ACTION_TYPES[type];
  return {
    actCode: ictConfig.actCode,
    contentsType: ictConfig.contentsType,
    contentsValue: type === 'goBJ' ? userId : ictConfig.contentsValue,
  };
};